import React, { useEffect, useState } from 'react';
import Breadcrumbs from '@storeblocks/breadcrumbs';
import { Skeleton, Title, Wrap } from './styled';
import { isApp } from '../../app/global';
import useIsMobileScreenSize from '../../utils/isMobileScreenSize';
function Heading(_a) {
    var title = _a.title, children = _a.children;
    var _b = useState(false), isSticky = _b[0], setIsSticky = _b[1];
    useEffect(function () {
        var wrapper = document.querySelector('body');
        var observer = new IntersectionObserver(function (_a) {
            var e = _a[0];
            setIsSticky(!e.isIntersecting);
        }, {
            rootMargin: '0px 0px 1000px 0px',
            threshold: [1],
        });
        if (wrapper) {
            observer.observe(wrapper);
        }
        return function () { return observer.unobserve(wrapper); };
    }, []);
    var collapseLimit = useIsMobileScreenSize() ? 2 : 3;
    return (React.createElement(Wrap, { "$isSticky": isSticky },
        !isApp && (React.createElement(Breadcrumbs, { collapseLimit: collapseLimit }, children)),
        title ? React.createElement(Title, { "data-hj-suppress": true }, title) : React.createElement(Skeleton, null)));
}
export default Heading;
